import { render, staticRenderFns } from "./PlacementsFilters.vue?vue&type=template&id=956d1d9c"
import script from "./PlacementsFilters.vue?vue&type=script&lang=js"
export * from "./PlacementsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports